<template>
  <div>
    <b-notification type="is-warning is-light">
      {{ $t(purpose_of_questions_and_answers_tab) }}
    </b-notification>

    <div v-for="item in questions_and_answers" :key="item.id" class="box qa-box">
      <div class="content">
        <div class="pb-1">
          <b>{{ item.topic }}</b><br/>
          <div class="font12px">{{ $t('question-and-answer.created_at') }}: {{ item.date }}</div>
        </div>
        <div class="qa-question">
          <p>{{ item.question }}</p>
        </div>
        <div v-if="item.answer" class="pt-1">
          <b>{{ $t('question-and-answer.reply_from_instructor') }}</b>
          <p class="qa-answer">{{ item.answer }}</p>
        </div>
      </div>
    </div>

    <b-button v-if="pagination.total > limit"
              type="is-primary"
              expanded
              outlined
              @click="loadMore">
      {{ $t('question-and-answer.load_more') }}
    </b-button>
    <hr v-if="questions_and_answers.length">

    <div>
      <h2 class="pb-1"><b>{{ $t('question-and-answer.ask_a_question') }}</b></h2>

      <b-field label="Topic"
               :type="form.errors.has('topic') ? 'is-danger': ''"
               :message="form.errors.get('topic')">
        <b-input v-model="form.topic"></b-input>
      </b-field>

      <b-field label="Question"
               :type="form.errors.has('question') ? 'is-danger': ''"
               :message="form.errors.get('question')">
        <b-input v-model="form.question" type="textarea"></b-input>
      </b-field>

      <b-button expanded type="is-success" @click="send">{{ $t('question-and-answer.send') }}</b-button>
    </div>
  </div>
</template>

<style>
  .course-tabs .qa-question {
    font-size: 14px;
  }
  .course-tabs .qa-answer {
    margin-top: 0.5em;
    margin-left: 2em;
    font-style: italic;
    font-size: 14px;
  }
  .course-tabs .font12px {
    font-size: 12px;
  }
  .course-tabs .qa-box {
    background-color: #f0f8ff;
  }
  .course-tabs .fa-comments-o {
    padding-bottom: 3px !important;
  }
</style>

<script>
import Form from '../../helpers/Form/Form';
import axios from 'axios';

export default {
  name: 'QuestionsAndAnswers',
  props: {
    send_route: { type: String, required: true },
    get_questions_and_answers_route: { type: String, required: true },
    chapter_name: { type: String, required: true },
    schedule_id: { type: Number, required: true },
    is_wizzair_program: { type: Boolean, default: false }
  },
  data() {
    return {
      form: new Form({
        topic: this.chapter_name,
        question: '',
        schedule_id: this.schedule_id
      }),
      questions_and_answers: [],
      limit: 5,
      pagination: {}
    };
  },
  computed: {
    purpose_of_questions_and_answers_tab() {
      return this.is_wizzair_program ? 'question-and-answer.purpose_of_questions_and_answers_tab_wizzair' : 'question-and-answer.purpose_of_questions_and_answers_tab';
    }
  },
  mounted() {
    this.getQuestionsAndAnswers();
  },
  methods: {
    send() {
      this.form.post(this.send_route)
        .then(response => {
          this.form.reset();
          this.getQuestionsAndAnswers();
          Swal.fire({
            title: 'Success!',
            text: 'Your question was sent to instructor.',
            type: 'success'
          });
        })
        .catch(error => {
          Swal.fire({
            title: 'Error!',
            type: 'error'
          });
        });
    },
    getQuestionsAndAnswers() {
      axios.get(this.get_questions_and_answers_route, { params: { limit: this.limit } })
        .then(({ data }) => {
          this.questions_and_answers = data.data;
          this.pagination = data.meta.pagination;
        });
    },
    loadMore() {
      this.limit += 5;
      this.getQuestionsAndAnswers();
    }
  }
};
</script>
